import React from "react";
import icon from "../assets/images/icon.png";
import NavigationBar from "../components/ui/Navbar";
import { UserAuth } from "../lib/authContext";
import { authEmails } from "../lib/constants";

const Profile = () => {
  const { user, userData, signOut } = UserAuth();

  return (
    <>
      <NavigationBar />
      <main>
        <div
          className="lg:flex max-w-screen-2xl mx-auto pt-[6rem] md:pt-32 justify-evenly"
          id="profile"
        >
          <div className="flex flex-col p-5 space-y-10 bg-white shadow-md">
            <h1 className="text-3xl border-b pb-4">My Profile</h1>
            <div className="grid grid-cols-5 self-center">
              <img
                src={user?.photoURL ? user.photoURL : icon}
                className="mb-10 mr-5 object-contain rounded-full"
                height={250}
                alt={user?.displayName || ""}
              />
              <div className="col-span-5 lg:col-span-4 mx-2">
                <div className="flex flex-row items-center mb-5">
                  <p>Name:</p>
                  <input
                    value={user?.displayName || ""}
                    className="ml-2 rounded-xl p-2 w-60"
                    disabled
                  />
                </div>
                <div className="flex flex-row items-center mb-5">
                  <p>Email:</p>
                  <input
                    value={userData?.email || ""}
                    className="ml-2 rounded-xl p-2 w-60"
                    disabled
                  />
                </div>
              </div>
            </div>
            {userData?.email && authEmails.includes(userData.email) && (
              <button
                className="flex items-center select-none text-black bg-gradient-to-b from-[#fce96a] to-[#e3a008] rounded-md focus:outline-none hover:from-yellow-500 hover:to-yellow-400 px-3 py-2 self-center"
                onClick={() =>
                  window.open("https://zzeeh-nexus.vercel.app", "_blank")
                }
              >
                <p>Create order on Nexus</p>
              </button>
            )}
            <button
              className="bg-red-600 hover:bg-red-700 text-white rounded-lg py-3 px-5 self-center"
              onClick={signOut}
            >
              Logout
            </button>
          </div>
        </div>
      </main>
    </>
  );
};

export default Profile;
